import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import HrLeaveApprovals from '../HrLeaveApprovals';
import WfhApprovals from './WfhApprovals';

export default function HrTimeOffApprovals() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('leaves');

  return (
    <div className="space-y-6">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
        <div>
          <button
            type="button"
            onClick={() => navigate('/EmpDashboard')}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-500 hover:text-blue-600 transition-colors mb-2 cursor-pointer group"
          >
            <FiArrowLeft size={14} className="group-hover:-translate-x-0.5 transition-transform" />
            <span>Back to Dashboard</span>
          </button>
          <h1 className="text-2xl font-black text-slate-900 tracking-tight">Leaves & WFH Approvals</h1>
          <p className="text-sm text-slate-500 font-medium mt-1">Review, approve, or reject employee leave applications and work-from-home requests</p>
        </div>
        
        <div className="flex items-center gap-1.5 p-1.5 bg-slate-100/80 rounded-2xl border border-slate-200/60">
          <button 
            onClick={() => setActiveTab('leaves')} 
            className={`px-5 py-2.5 rounded-xl text-xs font-bold transition-all ${activeTab === 'leaves' ? 'bg-white text-blue-600 shadow-sm border border-slate-200/60' : 'text-slate-600 hover:text-slate-900'}`}
          >
            Leave Approvals
          </button>
          <button 
            onClick={() => setActiveTab('wfh')} 
            className={`px-5 py-2.5 rounded-xl text-xs font-bold transition-all ${activeTab === 'wfh' ? 'bg-white text-blue-600 shadow-sm border border-slate-200/60' : 'text-slate-600 hover:text-slate-900'}`}
          >
            WFH Requests
          </button>
        </div>
      </div>

      <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
        {activeTab === 'leaves' ? (
          <div>
            <HrLeaveApprovals />
          </div>
        ) : (
          <div>
            <WfhApprovals />
          </div>
        )}
      </div>
    </div>
  );
}

